// extracted by mini-css-extract-plugin
module.exports = {"tabWrap":"hL9jtST-i2XPLu7bv8Uncw==","tabBox":"EYUO4fFX2Cf55OZf748GQw==","tabDiv":"kG0f0udPxjofyyzCJcjLOA==","activity":"SMtez--U1CuEglJ0wgYXbw=="};